import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {mainViewComponent} from "./main-view.component";

@NgModule({
    declarations: [mainViewComponent],
    imports     : [BrowserModule],
})

export class MainViewModule {}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/main-view/main-view.module.ts